import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

// 引入 element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI, { size: 'small' })
Vue.use(ElementUI, { size: 'mini' })

// 封装axios请求
import {get, post, uploadImage} from '@/common/js/require.js'
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$uploadImage = uploadImage

// cookie 工具
import Cookies from 'js-cookie'
Vue.prototype.Cookies =  Cookies

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js